import EVENT from '../enums/event.js';
import STATE from '../enums/state.js';

/* eslint-disable */
class SubscriptionOptions extends HTMLElement {
  constructor() {
    super();

    this.sellingPlanId;
    this.initialiseSellingPlan();
    this.registerEvents();
  }

  /**
   *
   * @param {'open'|'closed'} state
   */
  setState(state) {
    this.dataset.state = state;
  }

  /**
   *
   * @returns {'open'|'closed'} options toggle state.
   */
  getState() {
    return this.dataset.state;
  }

  /**
   *
   * @returns {string} selling plan id.
   */
  getSellingPlanId() {
    return this.subscriptionOption[0].dataset.option;
  }

  /**
   * Method that sets the selling plan when toggle is activated.
   */
  initialiseSellingPlan() {
    this.subscriptionOption = [
      ...document.querySelectorAll('subscription-option'),
    ].filter(option => option.dataset.selected === 'true');

    this.sellingPlanId = this.getSellingPlanId();

    if (this.getState() === STATE.SUBSCRIPTION.OPTIONS.OPEN) {
      this.setSellingPlan(this.sellingPlanId);
    }
  }

  /**
   *
   * @param {string} id
   * Set the selling plan query parameter and updates the history API.
   */
  setSellingPlan(id) {
    const params = new URLSearchParams(window.location.search);

    params.set('selling_plan', id);
    history.pushState({}, '', `${window.location.pathname}?${params}`);
  }

  /**
   * This removes the selling plan query parameter and updates the history API.
   */
  removeSellingPlan() {
    const params = new URLSearchParams(window.location.search);

    params.delete('selling_plan');
    history.pushState({}, '', `${window.location.pathname}?${params}`);
  }

  registerEvents() {
    document.addEventListener(
      EVENT.SUBSCRIPTION.SELECTOR.SELECTED,
      ({ detail }) => {
        if (detail.name === 'subscription') {
          this.setState(STATE.SUBSCRIPTION.OPTIONS.OPEN);
          this.initialiseSellingPlan();
        } else {
          this.setState(STATE.SUBSCRIPTION.OPTIONS.CLOSED);
          this.removeSellingPlan();
        }
      }
    );

    document.addEventListener(
      EVENT.SUBSCRIPTION.OPTION.SELECTED,
      ({ detail }) => {
        this.setSellingPlan(detail.option);
      }
    );
  }
}
/* eslint-enable */

customElements.define('subscription-options', SubscriptionOptions);
